const CmmsConsentType = {
  HIPAA_NOTICE: 'HIPAA_NOTICE',
  MEDICAL_WAIVER: 'MEDICAL_WAIVER',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TELEAUDIOLOGY_CONSENT: 'TELEAUDIOLOGY_CONSENT',
} as const

type CmmsConsentType = typeof CmmsConsentType[keyof typeof CmmsConsentType]

type CmmsConsent = {
  granted: boolean
  metadata: Record<string, unknown>
  relation_gid: string
  type: string
  version: number
}

export { CmmsConsentType }

export type { CmmsConsent }
